import type { TFunction } from "@/hooks/useTranslation"

export const TranslationKeyCell = (t: TFunction) =>
  function TranslationKeyCellComponent(key: string) {
    return <span>{t(key)}</span>
  }
